import $ from "jquery";
import {ColorInput} from "./membership/ColorInput";
import {FileInput} from "./membership/FileInput";
import {GuardedRemove} from "./membership/GuardedRemove";
import {MarkerPositioning} from "./membership/MarkerPositioning";
import {mountJsx} from "mojave/mount";
import {RichTextEditor} from "./membership/RichTextEditor";
import {SortableHandler} from "./membership/SortableHandler";

// enable guarded remove component
const remove = new GuardedRemove();
remove.init();

// enable tooltips
$('[data-toggle="tooltip"]').tooltip();

// enable different integrations
$(".custom-file").each((index, element) => (new FileInput(element)).init());
mountJsx(".data-contract-marker-positioning", MarkerPositioning);

$(".color-picker").each((index, element) => new ColorInput(element).init());
$("[data-sortable]").each((index, element) => (new SortableHandler(element)).init());
$("textarea.rich-text-editor").each((index, element) => (new RichTextEditor(element)).init());
